import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { BLOCK_MENU_HIGHLIGHT_IDS } from '../../../constants/block.constants'

export const FullScreenControls = React.memo((props) => {
  const { classes, previewMode, loading, onClick } = props
  const fullScreenIsSupported =
    document.mozFullscreenEnabled || document.webkitFullscreenEnabled || document.fullscreenEnabled

  if (!fullScreenIsSupported) {
    return null
  }

  const fullscreenContainerClasses = classNames('fullscreen-container', classes.fullscreenContainer, {
    disabled: loading,
  })
  const actionButtonClasses = classNames('action-btn', classes.actionButton, { disabled: loading })

  return (
    <div className={fullscreenContainerClasses}>
      <span
        className={actionButtonClasses}
        onClick={onClick}
        {...(previewMode && {
          'data-highlighter-item': BLOCK_MENU_HIGHLIGHT_IDS.filePdf.blockButtonStyle,
          'data-highlighter-selector': '.action-btn, .zoom-container',
          'data-highlighter-parent': '.toolbar-container-items',
        })}
      >
        <i className='fas fa-expand-arrows-alt' />
      </span>
    </div>
  )
})

FullScreenControls.propTypes = {
  classes: PropTypes.object,
  loading: PropTypes.bool,
  previewMode: PropTypes.bool,
  onClick: PropTypes.func,
}

FullScreenControls.defaultProps = {
  classes: {},
  previewMode: false,
  loading: false,
  onClick: () => {},
}
